import { ISSUE } from '../../reduxs'

const initialIssueState = {
  facilityHashMap: {},
  issueDetail: '',
  imageFile: [],
  renderImages: [],
  selectedItemId: null,
  selectedItemName: null,
}

export default function issueReducer (state = initialIssueState, action) {
  switch (action.type) {
    case ISSUE.actionType.SET_FACILITY_HASH_MAP:
      return {
        ...state,
        facilityHashMap: action.data.facilityHashMap,
      }

    case ISSUE.actionType.SET_SELECTED_ITEM:
      return {
        ...state,
        selectedItemId: action.data.selectedItemId,
        selectedItemName: action.data.selectedItemName,
      }

    case ISSUE.actionType.SET_ISSUE_DETAIL:
      return {
        ...state,
        issueDetail: action.data.issueDetail,
      }

    case ISSUE.actionType.ADD_UPLOAD_IMAGE:
      return {
        ...state,
        imageFile: [...state.imageFile, action.data.imageFile],
        renderImages: [...state.renderImages, action.data.renderImages],
      }

    case ISSUE.actionType.SET_UPLOAD_IMAGE:
      return {
        ...state,
        imageFile: action.data.imageFile,
        renderImages: action.data.renderImages,
      }

    case ISSUE.actionType.CLEAR_ISSUE:
      const clearIssueData = {...initialIssueState}
      delete clearIssueData.facilityHashMap

      return {
        ...state,
        ...clearIssueData,
      }

    default:
      return state
  }
}
